<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col cols="12" md="11" offset="0" offset-md="1">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate
                >Recherche d'un référent
                <template v-slot:actions>
                  <v-icon class="mr-2" color="primary">mdi-plus</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <Autocomplete
                  v-model="referent"
                  title="Recherche du référent"
                  subtitle="La recherche s'effectue à partir des premières lettres du nom. Au moins 2 lettres sont requises."
                  :source="typeReferent"
                ></Autocomplete>
                <div class="text-center">
                  <v-btn
                    v-if="referent"
                    class="mx-2"
                    color="primary"
                    small
                    @click="addReferent"
                  >
                    <v-icon left>save</v-icon>Ajouter ce référent
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row v-if="referents.length > 0">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="referents"
            :items-per-page="10"
            item-key="id"
            sort-by="nom"
            class="elevation-1"
            dense
          >
            <template v-slot:[`item.action`]="{ item }">
              <ActionConfirmation
                icone="mdi-delete"
                title="Supprimer le référent"
                @ok="deleteReferent(item.id)"
              ></ActionConfirmation>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ActionConfirmation from "@/components/ActionConfirmation";
import Autocomplete from "@/components/Autocomplete";
import ApiReferentRepository from "@/repositories/ApiReferentRepository";

export default {
  name: "Referents",
  components: { ActionConfirmation, Autocomplete },
  props: {
    referents: {
      type: Array,
      required: true,
    },
    typeReferent: String,
    parentUnique: Boolean,
    infoParentUnique: String,
  },

  data() {
    return {
      headers: [
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom",
        },
        {
          text: "Prénom",
          align: "left",
          sortable: true,
          value: "prenom",
        },
        {
          text: "uid",
          align: "left",
          sortable: false,
          value: "uid",
        },
        {
          text: "Mail",
          align: "left",
          sortable: true,
          value: "mail",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ],
      referent: null,
    };
  },
  methods: {
    deleteReferent(id) {
      let referent = this.referents.find((referent) => {
        return referent.id === id;
      });
      this.$emit("deleteReferent", referent);
    },
    async addReferent() {
      // la personne à ajouter n'est pas déjà dans la liste?
      let referent = this.referents.find((referent) => {
        return referent.uid === this.referent.uid;
      });
      if (referent) {
        this.$toast.error("Ce référent est déjà dans la liste");
        return;
      }
      // la personne à ajouter n'est pas déjà référent avec un autre rôle?
      if (
        !this.referent.typeReferent ||
        (this.referent.typeReferent &&
          this.referent.typeReferent !== this.typeReferent)
      ) {
        let referentAutreType = await this.getReferentAutreTypeByUid(
          this.typeReferent,
          this.referent.uid
        );
        if (referentAutreType) {
          this.$toast.error(
            "Cette personne est déjà " +
              referentAutreType.typeReferent +
              " ; elle ne peut donc être ajoutée ici."
          );
          return;
        }
      }
      if (this.parentUnique && this.referent.id) {
        this.$toast.info(this.infoParentUnique);
      }
      this.$emit("addReferent", this.referent);
      this.referent = null;
    },
    async getReferentAutreTypeByUid(typeReferent, uid) {
      try {
        const referent = await ApiReferentRepository.getReferentAutreTypeByUid(
          typeReferent,
          uid
        );
        return referent;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
  },
};
</script>
